import { InMemoryCache } from "@apollo/client";
import cacheRedirects from "./cacheRedirects";
import fragmentTypes from "@bonliva-crm/graphql/generated/fragmentTypes.json";

export const cache = new InMemoryCache({
  dataIdFromObject: (item: any) => {
    const { _id, id, Email, __typename } = item;
    if (__typename === "Invoice") {
      return `${__typename}:${item.InvoiceNumber}`;
    }

    // Pipeline and Opportunity boards both expose the user id as `_id`, so
    // without disambiguating by `type` the second board's columns overwrite
    // the first in the cache. See CRMDEV-6787.
    if (__typename === "KanbanBoard" && item.type && _id !== undefined) {
      return `${__typename}:${item.type}:${_id}`;
    }

    if (__typename) {
      if (id !== undefined) {
        return `${__typename}:${id}`;
      }
      if (_id !== undefined) {
        return `${__typename}:${_id}`;
      }
      if (Email) {
        return `${__typename}:${Email}`;
      }
    }

    return null;
  },
  possibleTypes: fragmentTypes.possibleTypes,
  typePolicies: cacheRedirects
});
